import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { clientProductsRoute } from '../route';

export const clientCreateReportsForStateInstitutionsRoute = createRoute({
	path: '/create-reports-for-state-institutions',
	getParentRoute: () => clientProductsRoute,
	component: lazyRouteComponent(
		() => import('./ClientCreateReportsForStateInstitutionsPage'),
		'ClientCreateReportsForStateInstitutionsPage',
	),
});
